export default __webpack_public_path__ + "static/media/it.d8eb8c3e.svg";